// Maps a competitor-displacement integer (latest run minus oldest run within
// the threat-window) to the symbol + Tailwind color + label that the
// Competitors tab renders in both the threat table and the top-3 spotlight
// cards. Stable rows return an empty `arrow` because the literal "Stable"
// label already conveys "no movement" — the redundant "→" arrow was flagged
// in markup #73. Up/down deltas keep their directional arrows.

export function displacementSymbol(d) {
  if (d == null) return { arrow: '', color: 'text-gray-500', label: 'Stable' };
  if (d > 0) return { arrow: '↑', color: 'text-red-600 dark:text-red-400', label: `+${d}` };
  if (d < 0) return { arrow: '↓', color: 'text-emerald-600 dark:text-emerald-400', label: `${d}` };
  return { arrow: '', color: 'text-gray-500', label: 'Stable' };
}
